import React, { useEffect, useMemo, useReducer } from 'react';
import { resolutionEntity } from 'shared/entityDetails';
import { AsyncSearchableSelect } from 'shared/components/select/SearchableSelects';
import { compareArrayOfObjects } from 'shared/utils';
import { DataReducerActions } from 'shared/reducers';

export function compileSearchString(ticketTags) {
  if (ticketTags.length > 0) {
    let tagSearch = `tag_id=${ticketTags[0].tag_id}`;
    if (ticketTags.length > 1) {
      ticketTags.forEach((tag, i) => {
        if (i !== 0) {
          tagSearch += (`&tag_id=${tag.tag_id}`);
        }
      });
    }
    return tagSearch;
  }
  return '';
}

export function compileUpdatedSearchString(updatedTicketTags) {
  let tagSearch = `tag_id=${updatedTicketTags[0]?.id}`;
  if (updatedTicketTags.length > 1) {
    updatedTicketTags.forEach((tag, i) => {
      if (i !== 0) {
        tagSearch += (`&tag_id=${tag.id}`);
      }
    });
  }
  return tagSearch;
}

function resolverReducer(state, {
  action,
  payload,
}) {
  switch (action) {
    case 'changeResolutions':
      return {
        resolution: undefined,
        ticketTags: payload,
      };
    case 'set':
      return { ...state, ...payload };
    default:
      return state;
  }
}

/**
 * @param {Object} props
 * @param {Object} props.data
 * @param {boolean} props.display
 * @param {Function} props.handleChange
 * @param {Object} props.updatedData
 */
export default function TicketResolver(props) {
  const {
    data: {
      ticket_tags: currentTicketTags,
      ticket_resolution: ticketResolution,
    },
    display,
    handleChange,
    updatedData,
  } = props;

  const {
    staged_ticket_tags: updatedTicketTags,
    resolution_id: updatedResolutionId,
  } = updatedData;

  const [resolverState, resolverDispatch] = useReducer(
    resolverReducer,
    { ticketTags: currentTicketTags },
  );

  const {
    resolution,
    ticketTags,
  } = resolverState;

  const baseSearch = useMemo(() => {
    if (updatedTicketTags) {
      return compileUpdatedSearchString(updatedTicketTags);
    }
    return compileSearchString(currentTicketTags);
  }, [currentTicketTags, updatedTicketTags]);

  const selectedOption = useMemo(() => {
    if (updatedResolutionId && resolution?.id) {
      return resolution;
    }
    if (ticketResolution) {
      return ticketResolution.resolution;
    }
    return undefined;
  }, [resolution, ticketResolution, updatedResolutionId]);

  useEffect(() => {
    if (updatedTicketTags && !compareArrayOfObjects(updatedTicketTags, ticketTags)) {
      resolverDispatch({
        action: 'changeResolutions',
        payload: updatedTicketTags,
      });
      handleChange('resolution_id', undefined);
    }
  }, [ticketTags, handleChange, updatedTicketTags]);

  const onChange = (r) => {
    resolverDispatch({
      action: DataReducerActions.set,
      payload: { resolution: r },
    });
    handleChange('resolution_id', r?.id);
  };

  if (!display || !baseSearch) return null;

  return (
    <AsyncSearchableSelect
      baseSearch={baseSearch}
      disableClearable
      onChange={onChange}
      label={resolutionEntity.label}
      searchRequest={resolutionEntity.searchRequest}
      selectedOption={selectedOption}
    />
  );
}
